import { fetchWithTokenRefresh } from './AuthActions';
import {
  achievements_returned,
  achievement_earned,
  earned_achievements_returned
} from './types';
import env from '../globals/environment';
import socket from '../globals/socket';

export const getAchievements = () => {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const { headers } = state.authStore;
      const { currentUser } = state.usersStore;
      const response = await fetchWithTokenRefresh(`${env.backendUrl}/achievements`, { headers })(dispatch);

      if (!response.ok) throw new Error('Could not get achievements from api');
      else {
        const achievements = await response.json();

        dispatch({
          type: achievements_returned,
          payload: achievements
        });

        socket.on('achievement', achievement => {
          if (achievement.user === currentUser.uid) {
            dispatch({
              type: achievement_earned,
              payload: achievements.filter(ach => ach._id === achievement.achievement)[0]
            });
          }
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
};

export const getUserAchievements = id => {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const { headers } = state.authStore;
      const response = await fetchWithTokenRefresh(`${env.backendUrl}/achievements/${id}/earned`, { headers })(dispatch);

      if (!response.ok) throw new Error('Could not get user achievements from api');
      else {
        const achievements = await response.json();

        dispatch({
          type: earned_achievements_returned,
          payload: achievements
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
};



// WEBPACK FOOTER //
// ./src/actions/AchievementActions.js